import React, { useCallback, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import { useTable, usePagination } from "react-table";
import { COLUMNS } from "./columns";
import {
  FaPlusCircle,
  FaMinusCircle,
  FaTimes,
  FaPlus,
  FaPencilAlt
} from "react-icons/fa";
import { FeeaddModal } from "../../../modals/FeeaddModal";
import { FeeEditModal } from "../../../modals/FeeEditModal";
import { SuccessfullModal } from "../../../modals/SuccessfullModal";
import { showToast } from "../../../../utils/utils";
import styles from "./../../../../assets/scss/custom.module.scss";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./feetable.scss";
import { commonErrMsg, noDataPresent, tooltips } from "../../../../locales/en";
import { ddMMMyyyy } from "../../../../utils/constants/appConstants";
import { showToastType } from "../../../../utils/constants/appConstants";
import { getQuoteFeeAdjustmentsSoftDeleteUrl } from "../../../../utils/constants/apiEndPoints";
import privateAxios from "../../../../utils/axiosPrivate";
import { useDispatch, useSelector } from "react-redux";
import { getFeeAdjusmentData } from "../../../../redux/invoiceDetailsSlice";
import { useParams } from "react-router-dom";
const FeeTable = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [sendID, setsendID] = useState("");
  const [sendtrue, setSendtrue] = useState(false);
  const [showSuccessfulModal, setShowSuccessfulModal] = useState(false);
  const feeAdjustmentData = useSelector(
    (state) => state.invoiceDetails.feeAdjustmentsData
  );

  const tooltipsArray = useMemo(
    () => [
      { id: "tooltip-addFee", content: tooltips?.addFee },
      { id: "tooltip-edit", content: tooltips?.edit },
      { id: "tooltip-delete", content: tooltips?.delete }
    ],
    []
  );

  const [editFeeModal, setEditFeeModal] = useState(false);
  const toggleEditFeeModal = useCallback((rowId) => {
    setEditFeeModal((prev) => !prev);
    setsendID(rowId);
    setSendtrue(true);
  }, []);

  const [addFeeModal, setAddFeeModal] = useState(false);
  const toggleAddFeeModal = useCallback(() => {
    setAddFeeModal((prev) => !prev);
  }, []);

  const columns = useMemo(() => COLUMNS, []);

  const data = useMemo(() => {
    return feeAdjustmentData?.data?.filter((item) => !item.deletedAt) || [];
  }, [feeAdjustmentData]);

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    useTable(
      {
        columns,
        data: data || []
      },
      usePagination
    );

  const [expandedRows, setExpandedRows] = useState([]);

  const toggleRow = useCallback((rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  }, []);

  const isRowExpanded = (rowId) => expandedRows.includes(rowId);

  const handleDeleteClick = async (rowId) => {
    try {
      const response = await privateAxios.patch(
        getQuoteFeeAdjustmentsSoftDeleteUrl(rowId)
      );

      if (response.status === 200) {
        await dispatch(getFeeAdjusmentData(id)).unwrap();
        showToast(commonErrMsg?.feeAdjustMent, showToastType?.success);
      }
    } catch (error) {
      showToast(
        error.response?.data?.message || showToastType?.errorText,
        showToastType?.error
      );
    }
  };

  useEffect(() => {
    if (id) {
      dispatch(getFeeAdjusmentData(id));
    }
  }, [dispatch, id]);

  return (
    <>
      <table className="feedatatable" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key, ...rest } = headerGroup.getHeaderGroupProps();
            return (
              <tr className="parentrow" {...rest} key={key}>
                <th />
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} key={column.id}>
                    <span>{column.render("Header")}</span>
                  </th>
                ))}
                <th className="text-end" />
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.length === 0 ? (
            <tr>
              <td colSpan={columns.length + 2} className="text-center">
                {noDataPresent}
              </td>
            </tr>
          ) : (
            page.map((row) => {
              prepareRow(row);
              const isExpanded = isRowExpanded(row.id);
              return (
                <React.Fragment key={row.id}>
                  <tr className="parentrow" {...row.getRowProps()}>
                    <td>
                      <span
                        className="expandbtn cursor-pointer"
                        onClick={() => toggleRow(row.id)}
                      >
                        {isExpanded ? <FaMinusCircle /> : <FaPlusCircle />}
                      </span>
                    </td>
                    {row.cells.map((cell) => {
                      const { key, ...cellProps } = cell.getCellProps();
                      return (
                        <td key={key} {...cellProps}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                    <td>
                      <ul
                        className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center`}
                      >
                        {row.original?.adjustmentType !== "On Schedule" ? (
                          ""
                        ) : (
                          <>
                            <li>
                              <button
                                className={`${styles.btnPrimary} edit-btn added-icon`}
                                onClick={() =>
                                  toggleEditFeeModal(row.original.id)
                                }
                                data-tooltip-id="tooltip-edit"
                                data-tooltip-content={tooltips.edit}
                              >
                                <FaPencilAlt />
                              </button>
                            </li>
                            <li>
                              <button
                                className={`${styles.btnPrimary} added-icon`}
                                onClick={() =>
                                  handleDeleteClick(row.original.id)
                                }
                                data-tooltip-id="tooltip-delete"
                                data-tooltip-content={tooltips.delete}
                              >
                                <FaTimes />
                              </button>
                            </li>
                          </>
                        )}
                      </ul>
                    </td>
                  </tr>
                  {isExpanded && (
                    <tr className="childrow">
                      <td colSpan={columns.length + 2}>
                        <div className="tdbody">
                          {columns.map((column) => {
                            return (
                              <span
                                key={column.accessor}
                                data-label={column.Header}
                              >
                                {column.accessor === "completedAt"
                                  ? format(
                                      new Date(row.original[column.accessor]),
                                      ddMMMyyyy
                                    )
                                  : String(row.original[column.accessor])}
                              </span>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>
      <div className="row mt-2">
        <div className="col-12">
          <div className={styles.tableactions}>
            <ul
              className={`${styles.btngroupwrap} d-flex justify-content-end align-items-center`}
            >
              <li>
                <button
                  className={`${styles.btnPrimary} add-new`}
                  onClick={() => toggleAddFeeModal()}
                  data-tooltip-id="tooltip-addFee"
                >
                  <FaPlus />
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Add/Edit modal */}
      <FeeEditModal
        isOpen={editFeeModal}
        toggle={toggleEditFeeModal}
        sendID={sendID}
        sendtrue={sendtrue}
        setSendtrue={setSendtrue}
        quoteID={id}
      />
      <FeeaddModal
        isOpen={addFeeModal}
        toggle={toggleAddFeeModal}
        invData={data}
        quoteID={id}
      />
      <SuccessfullModal
        isOpen={showSuccessfulModal}
        toggle={() => setShowSuccessfulModal(false)}
        title=""
        message="Successfully update payment."
      />
      {tooltipsArray.map(({ id, content }) => (
        <ReactTooltip
          key={id}
          className="tooltipcustom"
          id={id}
          content={content}
          place="top"
        />
      ))}
    </>
  );
};

FeeTable.propTypes = {
  invData: PropTypes.shape({
    quoteFeeAdjustmentList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        adjustmentType: PropTypes.string,
        feeAdjustToday: PropTypes.number,
        deletedAt: PropTypes.any,
        completedAt: PropTypes.any
      })
    ),
    internalQuoteStatusId: PropTypes.number,
    fundedAt: PropTypes.any,
    repaymentDate: PropTypes.any,
    dueDate: PropTypes.any,
    feeTillDueDate: PropTypes.number,
    feeUntilDueDate: PropTypes.number,
    promoDiscountAmount: PropTypes.number,
    signupDiscount: PropTypes.number,
    overdueFee: PropTypes.number,
    onScheduleAmount: PropTypes.number
  }),
  fetchInvoiceData: PropTypes.func.isRequired
};

export default FeeTable;
